<template>
  <v-dialog v-model="showModal" persistent max-width="500" :overlay="true">
    <v-card color="blue" class="white--text">
      <v-toolbar tabs>
        <v-toolbar-title id="title">Project Version Selection</v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap>
        <v-flex xs12>
          <v-list two-line>
            <v-subheader>All Save Versions History</v-subheader>
            <v-divider></v-divider>
            <div v-for="(item, index) in reversedVersions" :key="item.title">
              <v-list-tile avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="(index + 1) + '. ' + item.title"></v-list-tile-title>
                  <v-list-tile-action-text v-html="'Saved by user: '"></v-list-tile-action-text>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-spacer></v-spacer>
                  <td class="justify-left layout px-0">
                    <v-btn icon @click="selectVersion(item); $emit('hide-modal')" class="mx-0" title="Select Version">
                      <v-icon color="cyan">open_in_browser</v-icon>
                    </v-btn>
                  </td>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider></v-divider>
            </div>
          </v-list>
        </v-flex>
      </v-layout>
      <v-toolbar tabs>
        <v-spacer></v-spacer>
        <v-btn class="black--text" flat @click.native="$emit('hide-modal')">Close</v-btn>
      </v-toolbar>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    versions: Array
  },
  data: () => ({
  }),
  methods: {
    selectVersion(item) {
      this.$emit('select-version', item);
    }
  },
  computed: {
    reversedVersions: function() {
      // slice to make a copy of array, then reverse the copy
      return this.versions.slice().reverse();
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Workspace/Menus/ProjectVersionSelectionModal.vue